import ProfilesUpdatesStatisticsReducer from './ProfilesUpdatesStatisticsReducer';

export default from './ProfilesUpdatesStatisticsContainer';
export const ProfilesUpdatesStatisticsReducers = {
  ProfilesUpdatesStatisticsReducer,
};
